import { BugGroupGeneratedEntity } from "./generated/BugGroupGeneratedEntity";

export abstract class BugGroupEntity extends BugGroupGeneratedEntity {
    // Comment to preserve new line
}
